import { render, staticRenderFns } from "./UserPasswordIcon.vue?vue&type=template&id=2182f14a&scoped=true&"
import script from "./UserPasswordIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./UserPasswordIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2182f14a",
  null
  
)

export default component.exports